export default __webpack_public_path__ + "static/media/lyon-stEx-station.9a3cac35.webp";